import { capitalizeString } from "@/utils/strings";

export function CustomerData({ customer }: { customer: any }) {
  return (
    <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
      <div className="p-6 border-b border-gray-100">
        <h3 className="text-xs font-bold text-gray-400 mb-3 uppercase tracking-wider">Datos del Cliente</h3>
        <div className="space-y-1">
          <p className="text-base font-semibold text-gray-900">
            {customer?.customerName}
            <span className="text-sm font-normal text-gray-900"> ({customer?.customerCode})</span>
          </p>
          <div className="flex items-center gap-2 text-sm text-gray-600 mt-2">
            <span className="font-mono bg-gray-100 px-1.5 py-0.5 rounded text-xs">{customer?.customerDocType}</span>
            <span>{customer?.customerDocNumber}</span>
          </div>
          {!customer?.payerCode && <p className="text-sm text-gray-600 mt-1">{customer && capitalizeString(customer.customerIvaCondition)}</p>}
          <p className="text-sm text-gray-500 mt-2 leading-snug">{customer?.customerAddress}</p>
        </div>
      </div>
      {customer?.payerCode && <div className="p-6 border-b border-gray-100">
        <h3 className="text-xs font-bold text-gray-400 mb-3 uppercase tracking-wider">Datos de Facturación</h3>
        <div className="space-y-1">
          <p className="text-base font-semibold text-gray-900">
            {customer?.payerName}
            <span className="text-sm font-normal text-gray-900"> ({customer?.payerCode})</span>
          </p>
          <div className="flex items-center gap-2 text-sm text-gray-600 mt-2">
            <span className="font-mono bg-gray-100 px-1.5 py-0.5 rounded text-xs">{customer?.payerDocType}</span>
            <span>{customer?.payerDocNumber}</span>
          </div>
          <p className="text-sm text-gray-600 mt-1">{customer && capitalizeString(customer.customerIvaCondition)}</p>
          <p className="text-sm text-gray-500 mt-2 leading-snug">{customer?.payerAddress}</p>
        </div>
      </div>}
    </div>
  )
}
